<template>
    <div class="newsList">
        <div class="wrap">
            <Breadcrumb separator=">">
                <BreadcrumbItem to="/about">我们是</BreadcrumbItem>
                <BreadcrumbItem>新闻中心</BreadcrumbItem>
                <!-- <BreadcrumbItem></BreadcrumbItem> -->
            </Breadcrumb>
            <Row>
                <Col span="16">
                    <div class="newsBT">最新文章</div>
                    <div class="newsList-con" v-for="(list, index) in newList" :key="index"  @click="clickList(list.id)">
                        <ul>
                            <li>
                                <div class="newsImg">
                                    <img :src="list.imageUrl"/>
                                </div>
                                <div class="news-con">
                                    <div class="news-tit">
                                        {{list.title}}
                                    </div>
                                    <div class="news-dec" v-html="list.introduction">
                                        <!-- {{list.remarks}} -->
                                    </div>
                                    <div class="news-date">
                                        {{list.releaseTimeStr}}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <Row type="flex" justify="center" class="margin-top-10 page-nation">
                        <Page :total="totalCount" @on-change="pageChange" @on-page-size-change="pageSizeChange"
                              :page-size="pageSize" :current="currentPage" show-total
                              :page-size-opts="[10, 20, 30, 40, 50]"></Page>
                    </Row>
                    <Spin :fix="true" v-show="loading"></Spin>
                </Col>
                <Col span="8">
                    <div class="hotNews">
                        <div class="newsBT">热门文章</div>
                        <div class="hotNews-list">
                            <Timeline>
                                <TimelineItem  v-for="(list, index) in articleList" :key="index">
                                    <a @click="clickList(list.id)">
                                       <p class="content">{{list.title}}</p>
                                       <p class="time">{{list.publishDate}}</p>
                                    </a>
                                    
                                </TimelineItem>

                            </Timeline>
                        </div>
                    </div>
                </Col>
            </Row>

        </div>
    </div>
</template>

<script>
    export default {
        name: "newsList",
        components:{

        },
        data(){
            return{
                newList:[
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDec:'近日，由上海市人民政府新闻办公室指导、上海日报社承办的“2021外滩国际合作高峰论坛”落幕，盛大天地从数百家公司中"',
                    //     newsDate:'2022-02-04',
                    //     newsImg:require('../assets/images/web/newsImg.jpg'),
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDec:'近日，由上海市人民政府新闻办公室指导、上海日报社承办的“2021外滩国际合作高峰论坛”落幕，盛大天地从数百家公司中脱颖而出，荣获“2021最具影响力品牌奖”，盛大天地运营管理公司助理总裁蒋蕾女士现',
                    //     newsDate:'2022-02-04',
                    //     newsImg:require('../assets/images/web/newsImg.jpg'),
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDec:'近日，由上海市人民政府新闻办公室指导、上海日报社承办的“2021外滩国际合作高峰论坛”落幕，盛大天地从数百家公司中脱颖而出，荣获“2021最具影响力品牌奖”，盛大天地运营管理公司助理总裁蒋蕾女士现',
                    //     newsDate:'2022-02-04',
                    //     newsImg:require('../assets/images/web/newsImg.jpg'),
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDec:'近日，由上海市人民政府新闻办公室指导、上海日报社承办的“2021外滩国际合作高峰论坛”落幕，盛大天地从数百家公司中脱颖而出，荣获“2021最具影响力品牌奖”，盛大天地运营管理公司助理总裁蒋蕾女士现',
                    //     newsDate:'2022-02-04',
                    //     newsImg:require('../assets/images/web/newsImg.jpg'),
                    // },
                ],
                articleList:[
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDate:'2022-02-04',
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDate:'2022-02-04',
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDate:'2022-02-04',
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDate:'2022-02-04',
                    // },
                    // {
                    //     newsTit:'喜讯 | 盛大天地荣获外滩国际合作高峰论坛“2021最具影响力品牌奖”',
                    //     newsDate:'2022-02-04',
                    // },
                ],
                loading:false,
                nodeId:0,
                totalCount: 0,
                currentPage: 1,
                pageSize: 5,
            }
        },
        methods:{
            geContents() {
                this.loading = true;
                const skipCount = (this.currentPage - 1) * this.pageSize;
                this.$http
                    .post('/api/services/app/CommonWeb/SearchContentsByNodeName', {
                        maxResultCount: this.pageSize,
                        skipCount: skipCount,
                        orderByType:"ReleaseTime",
                        nodeName:'运管新闻'
                        
                    })
                    .then((res) => {
                        console.log(res);
                        this.newList = res.data.result.items;
                        this.totalCount = res.data.result.totalCount;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getHotNews() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetHotContents?nodeName=运管新闻")
                    .then(res => {
                        this.articleList = res.data.result;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            pageSizeChange(pageSize) {
                this.pageSize = pageSize;
                this.geContents();
            },
            pageChange(page) {
                this.currentPage = page;
                this.geContents();
            },
            clickList(id){
                this.$router.push({path: '/newsDetail',query:{id:id}});
            },
        },
        mounted(){
            // this.nodeId = this.$route.query.nodeId;
            // console.log(this.$route.query.nodeId);
            this.geContents();
            this.getHotNews();
        },
    }
</script>

<style lang="less">
    .newsList{
        padding:20px 0;
        background-color: #fff;
        .newsBT{
            font-size:18px;
            color:#000;
            margin:20px 0;
        }
        .newsList-con{
            width: 100%;
            ul{
                li{
                    display: flex;
                    flex-flow: row;
                    border: 1px solid #E3E3E3;
                    margin-bottom:30px;
                    flex-flow: row;
                    align-items: center;
                    width:100%;
                    .newsImg{
                        width: 260px;
                        height:184px;
                        overflow: hidden;
                        background: #f5f5f5;
                        display: block;
                        flex: 1;
                        img{
                            display:block;
                            line-height:0;
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .news-con{
                        flex: 2;
                        padding:13px 30px 13px 30px;
                        .news-tit{
                            font-size:18px;
                            color:#000;
                            margin-bottom:12px;
                        }
                        .news-dec{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            margin-bottom:10px;
                            color:#999;
                            font-size:14px;
                            height:64px;
                        }
                        .news-date{
                             color:#666;
                            font-size:12px;
                        }
                    }
                }
                li:hover{
                    border: 1px solid #F5F5F5;
                    box-shadow: 0px 0px 20px 0px rgba(151, 151, 151, 0.5);
                }
            }
        }
        .hotNews{
            padding-left:30px;
            .hotNews-list{
                background: #FAFAFA;
                box-shadow: 0px 0px 1px 0px rgba(151, 151, 151, 0.5);
                padding:30px 20px;
                a{
                    color:#2E2F30 !important;
                }
            }
        }
        .ivu-timeline-item-head{
            background-color: #3377E7;
        }
        .ivu-timeline-item-tail,
        .ivu-timeline-item-head-blue{
            border-color:#3377E7;
            color:#3377E7;
        }
        .content{
            font-size: 14px;
            font-weight: bold;
        }
        .content:hover{
            color:#3377E7;
        }
        .time{
            padding-left: 5px;
            padding-top:10px;
        }
    }
</style>